/* LensAdvisor: "Edit Lenses" - swap an existing cart bundle for a new selection.
   The cart's Edit Lenses link (main-cart.liquid / cart-drawer.liquid) opens the
   frame's product page with the frame variant preselected and la_edit_* params
   identifying the OLD bundle line by title + variant + quantity. Cart-transform
   line KEYS are regenerated whenever the cart changes, so keys cannot be used
   as the identity (verified live 2026-07-29: the old line's key changed the
   moment the replacement was added).

   Flow: on the product page we auto-open the lens flow; when the replacement
   is added (LensAdvizor:addToCart:success) we arm a sessionStorage flag and go
   to the cart. On the cart page, the armed flag finishes the swap calmly (no
   unload race): find the old line by title+variant, reduce its quantity by the
   old amount (which also handles the customer re-picking the identical
   configuration, where the transform merges old+new into one line), then
   reload. Abandoning the flow never arms the flag, so nothing is removed. */

const laEditParams = new URLSearchParams(window.location.search);
const laEditTitle = laEditParams.get('la_edit_title');
const laEditVariant = laEditParams.get('la_edit_variant');
const laEditQty = parseInt(laEditParams.get('la_edit_qty') || '1', 10);
const LA_EDIT_FLAG = 'laEditSwapPending';

// ---- Product page: auto-open the flow, arm the swap on successful add ----
if (laEditTitle && laEditVariant) {
  // The lens modal is appended to the DOM when open and fully removed when
  // closed, so its presence is the reliable "flow is open" signal. The Select
  // Lenses button can exist in the DOM before the widget has wired its click
  // handler (and on metafield-driven stores init:complete fires from a timer
  // inside the widget, racing this script) - so keep clicking until the modal
  // actually appears, then stop for good. Self-terminating after ~15s.
  const laEditOpenFlow = () => {
    if (document.querySelector('.la-prescription-modal')) return;
    const selectLensesBtn = document.querySelector('#la-select-lenses-btn');
    if (selectLensesBtn) selectLensesBtn.click();
  };

  document.addEventListener('LensAdvizor:init:complete', laEditOpenFlow);
  laEditOpenFlow();
  let laEditPollCount = 0;
  const laEditPoll = setInterval(() => {
    laEditPollCount += 1;
    if (document.querySelector('.la-prescription-modal') || laEditPollCount > 50) {
      clearInterval(laEditPoll);
      return;
    }
    laEditOpenFlow();
  }, 300);

  document.addEventListener('LensAdvizor:addToCart:success', () => {
    sessionStorage.setItem(LA_EDIT_FLAG, JSON.stringify({
      title: laEditTitle,
      variant: laEditVariant,
      qty: laEditQty
    }));
    const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    window.location.href = `${root}cart`;
  });
}

// ---- Cart page: finish an armed swap ----
if (window.location.pathname.replace(/\/$/, '').endsWith('/cart') && sessionStorage.getItem(LA_EDIT_FLAG)) {
  const laEditFinishSwap = async () => {
    let pending;
    try {
      pending = JSON.parse(sessionStorage.getItem(LA_EDIT_FLAG));
    } catch (e) {
      pending = null;
    }
    // Clear first so a failed request can never repeat the decrement.
    sessionStorage.removeItem(LA_EDIT_FLAG);
    if (!pending || !pending.title) return;

    const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    // The cart transform can reorder the components in a merged line's title
    // between renders (observed live), so compare the component SET, not the
    // exact string.
    const laNormalizeTitle = (title) => String(title).split(' + ').map((part) => part.trim()).sort().join('|');
    const pendingTitleKey = laNormalizeTitle(pending.title);
    const oldLine = cart.items.find(
      (item) => laNormalizeTitle(item.title) === pendingTitleKey && String(item.variant_id) === String(pending.variant)
    );
    if (!oldLine) return;

    const targetQty = Math.max(0, oldLine.quantity - (pending.qty || 1));
    await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldLine.key, quantity: targetQty })
    });
    window.location.reload();
  };
  laEditFinishSwap();
}

// v2 2026-07-29 cache-bump
